"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const buttons_1 = require("../../atoms/buttons");
const hooks_1 = require("../../shared/hooks");
const react_i18next_1 = require("react-i18next");
const icons_1 = require("../../atoms/icons");
const typography_1 = require("../../shared/typography");
const Base_1 = require("./Base");
const OfflineModal = () => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { isOffline } = (0, hooks_1.useNetwork)();
    const [isVisible, setVisibility] = (0, react_1.useState)(false);
    const toggleVisibility = () => setVisibility(!isVisible);
    (0, react_1.useEffect)(() => {
        if (isOffline) {
            !isVisible && toggleVisibility();
        }
    }, [isOffline]);
    if (!isVisible)
        return null;
    return ((0, jsx_runtime_1.jsx)(Base, { onCloseModal: toggleVisibility, children: (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsxs)(Wrapper, { children: [(0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "rectangleBig", icon: ["far", "wifi-slash"], size: "2x" }, void 0), (0, jsx_runtime_1.jsx)(typography_1.H4, { children: t("offlineModal.general.firstSection") }, void 0), (0, jsx_runtime_1.jsx)(typography_1.H4, { children: t("offlineModal.general.secondSection") }, void 0), (0, jsx_runtime_1.jsxs)(typography_1.P, { children: [" ", t("offlineModal.general.thirdSection")] }, void 0), (0, jsx_runtime_1.jsx)(buttons_1.Button, { variant: "primary", onClick: toggleVisibility, children: t("offlineModal.cancelLabel") }, void 0)] }, void 0) }, void 0) }, void 0));
};
const Base = (0, styled_components_1.default)(Base_1.ModalBase) `
  & > div {
    background-color: ${({ theme }) => theme.colors.whiteBase};
    border-radius: ${({ theme }) => theme.utils.radius};
    min-height: 200px;
    margin: 10% auto;
    position: relative;
    overflow: hidden;
    max-width: 400px;

    @media (max-width: ${({ theme }) => theme.utils.breakpoints.phone}) {
      max-width: 20rem;
    }
  }
`;
const Wrapper = styled_components_1.default.div `
  align-items: center;
  border: 1px solid ${({ theme }) => theme.colors.silverBase};
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => `${theme.spacings.m} ${theme.spacings.xl}`};

  & > div {
    margin: ${({ theme }) => theme.spacings.m};
  }

  svg {
    color: ${({ theme }) => theme.colors.yellowBase};
  }

  p,
  h4 {
    display: block;
    margin-bottom: ${({ theme }) => theme.spacings.m};
    width: 100%;
  }

  p {
    text-align: center;
    margin: ${({ theme }) => theme.spacings.xl};
  }
`;
exports.default = OfflineModal;
//# sourceMappingURL=OfflineModal.js.map